// value отправляется на бек, в массиве показываем в каком фильтре отображать опцию
export const operationTypes = [
  { label: 'Top Up', value: 0, filter: ['balance'] },
  { label: 'Card Issuing Fee', value: 1, filter: ['balance'] },
  { label: 'Balance Transfer', value: 2, filter: ['balance'] },
  { label: 'Balance Transfer Echo', value: 3 },
  { label: 'Refunds for Balance', value: 5 },
  { label: 'Refunds Withdrawals', value: 6, filter: ['balance'] },
  { label: 'Compensation User', value: 7, filter: ['balance'] },
  { label: 'Commission per Payment', value: 8, filter: ['balance'] },
  { label: 'Walletester Balance Transfer', value: 9 },
  { label: 'Card Balance Transfer', value: 10 },
  { label: 'Transaction Payment', value: 11 },
  { label: 'Referral Balance Transfer', value: 12, filter: ['balance'] },
  { label: 'Card Monthly Fee', value: 13, filter: ['balance'] },
  { label: 'Balance Correction', value: 14 },
];

export const findOperationTypeLabel = (value) => {
  return operationTypes.find((type) => type.value === Number(value))?.label;
};

//------- balances
export const paymentStatuses = {
  0: 'waiting',
  1: 'completed',
  2: 'canceled',
  3: 'pending',
  4: 'created',
  5: 'frozen',
};

export const paymentStatusesOptions = Object.entries(paymentStatuses).map(
  ([key, value]) => ({
    label: value,
    value: key,
  }),
);
//-------

//------- cards
export const cardStatuses = {
  0: 'active',
  1: 'blocked',
  2: 'frozen',
  4: 'pending', // in_progress
  5: 'error',
  6: 'closed', // нету
  7: 'deleted', // нету
  8: 'inactive', // нету
  10: 'unknown', // нету
};

const DISPLAY_CARDS_STATUSES = [0, 1, 2];

export const cardStatusesOptions = Object.entries(cardStatuses)
  .filter(([key]) => DISPLAY_CARDS_STATUSES.includes(Number(key)))
  .map(([key, value]) => ({
    label: value,
    value: key,
  }));
//-------

//------- transactions
export const transactionStatuses = [
  { label: 'accepted', value: 'Accepted' },
  { label: 'held', value: 'Held' },
  { label: 'declined', value: 'Declined' },
];
//-------

export const findTeamStatusLabel = (row) => {
  if (row.is_frozen) {
    return 'frozen';
  }

  if (row.is_activated !== undefined) {
    return row.is_activated ? 'active' : 'inactive';
  }

  return 'active';
};
